import { frontendURL } from '../../../../helper/URLHelper';
import { TELEGRAM_AUDIENCE_PERMISSIONS } from 'dashboard/constants/permissions';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import SettingsWrapper from '../SettingsWrapper.vue';

const TelegramSettingsLayout = () => import('./TelegramSettingsLayout.vue');
const TelegramBotStructurePage = () => import('./pages/BotStructurePage.vue');
const TelegramAudiencePage = () => import('./pages/AudiencePage.vue');
const TelegramStatisticsPage = () => import('./pages/StatisticsPage.vue');
const TelegramChannelsGroupsPage = () =>
  import('./pages/ChannelsGroupsPage.vue');
const TelegramBotSettingsPage = () => import('./pages/BotSettingsPage.vue');

const adminOnlyMeta = {
  featureFlag: FEATURE_FLAGS.CHANNEL_TELEGRAM,
  permissions: ['administrator', TELEGRAM_AUDIENCE_PERMISSIONS],
};

const audienceManageMeta = {
  featureFlag: FEATURE_FLAGS.CHANNEL_TELEGRAM,
  permissions: ['administrator', TELEGRAM_AUDIENCE_PERMISSIONS],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/telegram'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'settings_telegram_bot_structure',
            params: to.params,
            query: to.query,
          }),
        },
        {
          path: '',
          component: TelegramSettingsLayout,
          children: [
            {
              path: 'bot-structure',
              name: 'settings_telegram_bot_structure',
              component: TelegramBotStructurePage,
              meta: adminOnlyMeta,
            },
            {
              path: 'audience',
              name: 'settings_telegram_audience',
              component: TelegramAudiencePage,
              meta: audienceManageMeta,
            },
            {
              path: 'statistics',
              name: 'settings_telegram_statistics',
              component: TelegramStatisticsPage,
              meta: adminOnlyMeta,
            },
            {
              path: 'autoposting',
              redirect: to => ({
                name: 'settings_telegram_channels_groups',
                params: to.params,
                query: to.query,
              }),
            },
            {
              path: 'channels-groups',
              name: 'settings_telegram_channels_groups',
              component: TelegramChannelsGroupsPage,
              meta: adminOnlyMeta,
            },
            {
              path: 'bot-settings',
              name: 'settings_telegram_bot_settings',
              component: TelegramBotSettingsPage,
              meta: adminOnlyMeta,
            },
          ],
        },
      ],
    },
  ],
};
